module.exports = __webpack_public_path__ + "img/success.e6e6fa2a.png";